<template>
  <div>
    <HeadlineContainer headline="Projects" :breadcrumbs="[{text: 'Projects'}]">
      <router-link to="/projects/create" class="btn btn-white">
        <i class="fa fa-plus"></i> Create
      </router-link>
    </HeadlineContainer>

    <LoadingContainer v-if="loading"/>

    <div v-else class="container">
      <ProjectList :portals="portals"/>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import ProjectList from '../../../components/Relations/Projects/Panels/List'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import LoadingContainer from "../../../components/Layout/LoadingContainer.vue";

export default {
  components: {LoadingContainer, ProjectList, HeadlineContainer},

  data() {
    return {
      portals: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/portals').then(response => {
        this.portals = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
